import { ReactNode } from "react";
import { introspection_types } from "../../graphql-env";
import { ResultOf, DocumentDecoration } from "gql.tada";
import { AudienceCulturalInfluenceSectionById } from "../../queries/entries/AudienceCulturalInfluenceById";
import { AudienceCulturalInfluenceSection } from "../entries/AudienceCulturalInfluenceSection";
import { CurveCarouselSection } from "../entries/CurveCarouselSection";
import { CurveCarouselSectionById } from "../../queries/entries/CurveCarouselSectionById";
import { DescriptionFillSectionById } from "../../queries/entries/DescriptionFillSectionById";
import { DescriptionFillSection } from "../entries/DescriptionFillSection";
import { GetStartedRoutingSectionById } from "../../queries/entries/GetStartedRoutingSectionById";
import { GetStartedRoutingSection } from "../entries/GetStartedRoutingSection";
import { InsightsBlockGroupById } from "../../queries/entries/InsightsBlockGroupById";
import { InsightsBlockGroup } from "../entries/InsightsBlockGroup";
import { DocumentInput } from "urql";
import { IntroBenefitsSectionById } from "../../queries/entries/IntroBenefitsSectionById";
import { IntroBenefitsSection } from "../entries/IntroBenefit/IntroBenefitsSection";
import { NewsReelSectionById } from "../../queries/entries/NewsReelSectionById";
import { NewsReelSection } from "../entries/NewsReelSection";
import { InspoCarouselSectionById } from "../../queries/entries/InspoCarouselSectionById";
import { InspoCarouselSection } from "../entries/InspoCarouselSection";
import { ProductMotionSlidesSectionById } from "../../queries/entries/ProductMotionSlidesSectionById";
import { ProductMotionSlidesSection } from "../entries/ProductMotionSlidesSection";
import { SlidingThumbnailHeroById } from "../../queries/entries/SlidingThumbnailHeroById";
import { SlidingThumbnailHero } from "../entries/SlidingThumbnailHero";
import { TitleSectionById } from "../../queries/entries/TitleSectionById";
import { TitleSection } from "../entries/TitleSection";
import { InsightsHeroById } from "../../queries/entries/InsightsHeroById";
import { InsightsHero } from "../entries/InsightsHero";
import { GetStartedSectionById } from "../../queries/entries/GetStartedSectionById";
import { GetStartedSection } from "../entries/GetStartedSection";
import { FAQSectionById } from "../../queries/entries/FAQSectionById";
import { FAQSection } from "../entries/FaqSection";
import { SolutionsHero } from "../entries/SolutionsHero";
import { SolutionsHeroById } from "../../queries/entries/SolutionsHeroById";
import { MediaGallerySectionById } from "../../queries/entries/MediaGallerySectionById";
import { MediaGallerySection } from "../entries/MediaGallerySection";
import { SolutionsSectionById } from "../../queries/entries/SolutionsSectionById";
import { SolutionsSection } from "../entries/SolutionsSection";
import { PartnershipsHero } from "../entries/PartnershipsHero";
import { PartnershipsHeroById } from "../../queries/entries/PartnershipsHeroById";
import { ColumnLegalSectionById } from "../../queries/entries/ColumnLegalSectionById";
import { ColumnLegalSection } from "../entries/ColumnLegalSection";
import { PartnershipListSectionById } from "../../queries/entries/PartnershipListSectionById";
import { PartnershipListSection } from "../entries/PartnershipListSection";

type EntryResolver<
  QueryDocument extends DocumentDecoration = DocumentDecoration
> = {
  query: DocumentInput;
  Component: ({ entry }: { entry: ResultOf<QueryDocument> }) => ReactNode;
};

export const EntryMap: Record<
  introspection_types["Entry"]["possibleTypes"],
  EntryResolver | null
> = {
  ArticlePage: null,
  ArticleSideBySideImages: null,
  AudienceCulturalInfluenceSection: {
    query: AudienceCulturalInfluenceSectionById,
    Component: AudienceCulturalInfluenceSection,
  },
  BenefitItem: null,
  ChooseYourOwnAdventureSection: null,
  FormOption: null,
  MediaGallerySection: {
    query: MediaGallerySectionById,
    Component: MediaGallerySection,
  },
  ContentType404Page: null,
  ContentTypeRichText: null,
  ColumnLegalSection: {
    query: ColumnLegalSectionById,
    Component: ColumnLegalSection,
  },
  CookieSettings: null,
  CookieFooter: null,
  CurveCarouselItem: null,
  CurveCarouselSection: {
    query: CurveCarouselSectionById,
    Component: CurveCarouselSection,
  },
  DescriptionFillSection: {
    query: DescriptionFillSectionById,
    Component: DescriptionFillSection,
  },
  ExploreCarouselItem: null,
  ExploreCarouselSection: null,
  FaqItem: null,
  FaqSection: {
    query: FAQSectionById,
    Component: FAQSection,
  },
  Footer: null,
  FooterLinkGroup: null,
  FormItemLongText: null,
  FormItemSelect: null,
  FormItemText: null,
  GetStartedDropDownOptions: null,
  GetStartedRoutingSection: {
    query: GetStartedRoutingSectionById,
    Component: GetStartedRoutingSection,
  },
  GetStartedSection: {
    query: GetStartedSectionById,
    Component: GetStartedSection,
  },
  IconGrid: null,
  Icons: null,
  InsightsBlockGroup: {
    query: InsightsBlockGroupById,
    Component: InsightsBlockGroup,
  },
  InsightsBlocks: null,
  InsightsHero: {
    query: InsightsHeroById,
    Component: InsightsHero,
  },
  InspoCarouselItem: null,
  InspoCarouselSection: {
    query: InspoCarouselSectionById,
    Component: InspoCarouselSection,
  },
  IntroBenefitsSection: {
    query: IntroBenefitsSectionById,
    Component: IntroBenefitsSection,
  },
  Link: null,
  Locale: null,
  MediaBackgroundHero: null,
  NavigationItem: null,
  NewsReelItem: null,
  NewsReelSection: {
    query: NewsReelSectionById,
    Component: NewsReelSection,
  },
  Page: null,
  PageMetadata: null,
  PartnershipListSection: {
    query: PartnershipListSectionById,
    Component: PartnershipListSection,
  },
  PartnershipListItem: null,
  ProductMotionSlide: null,
  ProductMotionSlidesSection: {
    query: ProductMotionSlidesSectionById,
    Component: ProductMotionSlidesSection,
  },
  SlidingThumbnailHero: {
    query: SlidingThumbnailHeroById,
    Component: SlidingThumbnailHero,
  },
  SlidingThumbnailHeroItem: null,
  Theme: null,
  TitleSection: {
    query: TitleSectionById,
    Component: TitleSection,
  },
  MediaGalleryItem: null,
  PartnershipsHero: {
    query: PartnershipsHeroById,
    Component: PartnershipsHero,
  },
  SolutionsChapterRow: null,
  SolutionsChapter: null,
  SolutionsSection: {
    query: SolutionsSectionById,
    Component: SolutionsSection,
  },
  SolutionsHero: {
    query: SolutionsHeroById,
    Component: SolutionsHero,
  },
};
